<template>
  <!-- Modal template -->
  <admin-modal v-show="show" :title="title" class="long" @cancel="closeModal">
    <!-- edit fields -->
    <template v-slot:body>
      <el-checkbox-group v-model="checkList" class="checkboxWrapper">
        <el-checkbox class="checkbox" label="warn">Warn</el-checkbox>
        <el-checkbox class="checkbox" label="info">Info</el-checkbox>
      </el-checkbox-group>
      <div class="modal__row">
        <!-- URL edting field -->
        <div v-if="filterSourceList.length > 0" class="modal__field long-field">
          <div
            v-for="(data, index) in filterSourceList"
            :key="index"
            class="modal__item"
          >
            <h3>
              {{ new Date(Number(data.eventTime)).toUTCString() }}
            </h3>
            <p>Level: {{ data.level }}</p>
            <p>Massage: {{ data.message }}</p>
          </div>
        </div>
        <div v-else class="defoultSource">Not source</div>
      </div>
    </template>

    <!-- footer -->
    <template v-slot:footer>
      <!-- Cancel button -->
      <div class="modal-btn cancel-btn" @click="closeModal">
        Cancel
      </div>
    </template>
  </admin-modal>
</template>

<script>
import AdminModal from "@/components/admin/modals/AdminModal.vue";
import { getAPI, token } from "@/api/params.js";

export default {
  name: "SourceInfoModal",
  components: {
    AdminModal
  },
  props: {
    // is modal shown
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Source"
    },
    streamName: {
      type: String
    },
    flagServer: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      sourceInfo: [],
      checkList: ["warn", "info"]
    };
  },
  computed: {
    filterSourceList() {
      return this.sourceInfo.filter(
        e => e.stream === this.streamName && this.checkList.includes(e.level)
      );
    }
  },
  watch: {
    flagServer() {
      fetch(`${getAPI()}/streamer_notify/list?token=${token}&category=source`)
        .then(response => response.json())
        .then(commits => {
          commits.map(e => {
            Number(e.eventTime);
          });
          this.sourceInfo = commits;
        });
    }
  },
  created() {
    fetch(`${getAPI()}/streamer_notify/list?token=${token}&category=source`)
      .then(response => response.json())
      .then(commits => {
        commits.map(e => {
          Number(e.eventTime);
        });
        this.sourceInfo = commits;
      });
  },
  methods: {
    closeModal() {
      // User try to close modal
      this.$emit("shangeFlagUpdateServer");
      this.$emit("close");
    }
  }
};
</script>
<style>
.checkboxWrapper .el-checkbox__input.is-checked + .el-checkbox__label {
  color: black;
}
.checkboxWrapper .el-checkbox__inner {
  background-color: #ddd;
  border: none;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background: #a39d9d;
}
</style>

<style scoped>
.modal__item {
  background-color: #c4c4c4;
  margin: 3px 0px;
  border-radius: 10px;
  padding: 4px;
}

.defoultSource {
  margin-top: 10px;
}

.checkbox {
  color: Black !important;
  /* border: 1px solid #564d4d; */
  /* padding: 6px; */
  /* border-radius: 6px; */
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background: #a39d9d;
}
.checkboxWrapper {
}
.el-checkbox-button .checkbox {
}
.el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: black;
}
.checkbox .is-checked {
  color: rgb(42, 53, 112) !important;
}
</style>
